module.exports = __webpack_public_path__ + "static/media/instagram-dark.c43f01b0.svg";